import {connect} from "react-redux";
import RmMeetingView from "./RmMeetingView";
import {bindActionCreators} from "redux";
import { viewActivity, activityList } from "../../../../service/Activity/action";
import { addTaggedAlong, getRmViewDetails, ratingSave } from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    activityByIdDetails:state.Activity.activityByIdDetails,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    getRmDetails: state.Dealer.getRmDetails,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewActivity,
            addTaggedAlong,
            getRmViewDetails,
            ratingSave,
            activityList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RmMeetingView);
